<template>
  <div>
    <ProofingImage
      :proofingCode="proofingCode"
      :disabled="disabled"
      class="mb-4"
    />
    <ProofingDoc :proofingCode="proofingCode" :disabled="disabled" />
  </div>
</template>

<script>
import ProofingDoc from './components/proofing-doc'
import ProofingImage from './components/proofing-image'
export default {
  components: { ProofingDoc, ProofingImage },
  props: {
    proofingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped></style>
